import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./index.css";
import { useNavigate } from "react-router-dom";
import OwnerAccountListViewComp from "../OwnerAccountListViewComp";

const OwnerAccountListView = ({
  data,
  handleRefresh,
  isopen,
  page,
  refreshAllData,
  refreshType,
  setRefreshtype,
  setFailedRefreshId,
  failedRefreshId,
  successRefreshId,
  setSuccessRefreshId,
  currency,
  splitView,
  postiveBalanceData,
  negativeBalanceData,
  refreshAll,
  typepop,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  txnPayLoad,
  setTxnPayLoad,
  BenEnableNextButton,
  setOpenOwner,
  flow,
  handleViewStatement,
  setStatementId,
  setAccData,
  setPrev_Total_balance_state,
  total_balance,
  handleButtonClick,
  favouritesFilter,
  multiSelect,
  isAssignTagsClicked,
  owneraccountnumberstate,
  setowneraccountnumberstate,
  popType,
  setpaymentBox,
  setRefactorAccDetail,
  isLabelClicked,
  handleOwnerAccountSelect,
  filterRef,
}) => {
  const { ownerAccBalanceLoading, ownerAccBalanceError } = useSelector(
    (state) => state.ownerAllVerification,
  );
  const [accId, setAccId] = useState("");
  const [prevId, setPrevId] = useState("");
  const [prevBalance, setPrevBalance] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listdata = data;

  return (
    <>
      {splitView ? (
        <div className="w-max-content-width mx-auto flex flex-col px-padding-sm">
          <div className="split_view_header pt-padding-md">
            <div className="w-width-md">
              <p>Positive Balance</p>
            </div>
            <div className="w-width-md pl-padding-xl">
              <p>Negative Balance</p>
            </div>
          </div>
          <div className="flex w-full">
            <div className="h-full w-width-full">
              <div className="standard-list-view-alignment animation_test w-width-md">
                {postiveBalanceData.length ? (
                  postiveBalanceData.map((item, index) => {
                    return (
                      <OwnerAccountListViewComp
                        filterRef={filterRef}
                        index={index}
                        item={item}
                        handleRefresh={handleRefresh}
                        isopen={isopen}
                        page={page}
                        refreshAllData={refreshAllData}
                        refreshType={refreshType}
                        setRefreshtype={setRefreshtype}
                        setFailedRefreshId={setFailedRefreshId}
                        failedRefreshId={failedRefreshId}
                        successRefreshId={successRefreshId}
                        setSuccessRefreshId={setSuccessRefreshId}
                        currency={currency}
                        refreshAll={refreshAll}
                        typepop={typepop}
                        setIsNeft={setIsNeft}
                        setIsImps={setIsImps}
                        setIsRtgs={setIsRtgs}
                        txnPayLoad={txnPayLoad}
                        setTxnPayLoad={setTxnPayLoad}
                        setpaymentBox={setpaymentBox}
                        BenEnableNextButton={BenEnableNextButton}
                        setOpenOwner={setOpenOwner}
                        flow={flow}
                        handleViewStatement={handleViewStatement}
                        ownerAccBalanceLoading={ownerAccBalanceLoading}
                        ownerAccBalanceError={ownerAccBalanceError}
                        navigate={navigate}
                        dispatch={dispatch}
                        accId={accId}
                        setAccId={setAccId}
                        setStatementId={setStatementId}
                        setAccData={setAccData}
                        prevId={
                          refreshType === "all"
                            ? refreshAllData?.find((id) => item.id === id.id)
                                ?.id
                            : prevId
                        }
                        setPrevId={setPrevId}
                        prevBalance={
                          refreshType === "all"
                            ? refreshAllData?.find((id) => item.id === id.id)
                                ?.prevbalance
                            : prevBalance
                        }
                        setPrevBalance={setPrevBalance}
                        setPrev_Total_balance_state={
                          setPrev_Total_balance_state
                        }
                        total_balance={total_balance}
                        handleButtonClick={handleButtonClick}
                        favouritesFilter={favouritesFilter}
                        multiSelect={multiSelect}
                        isAssignTagsClicked={isAssignTagsClicked}
                        isLabelClicked={isLabelClicked}
                        handleOwnerAccountSelect={handleOwnerAccountSelect}
                        owneraccountnumberstate={owneraccountnumberstate}
                        setowneraccountnumberstate={setowneraccountnumberstate}
                        popType={popType}
                        setRefactorAccDetail={setRefactorAccDetail}
                      />
                    );
                  })
                ) : (
                  <p
                    style={{ padding: "var(--padding-base)" }}
                    className="noaccountfound"
                  >
                    No accounts were found with a positive balance.
                  </p>
                )}
              </div>
            </div>
            <div className="owner_split_div"></div>
            <div className="standard-list-view-alignment animation_test2 w-width-md">
              {negativeBalanceData.length ? (
                negativeBalanceData.map((item, index) => {
                  return (
                    <OwnerAccountListViewComp
                      filterRef={filterRef}
                      index={index}
                      item={item}
                      handleRefresh={handleRefresh}
                      isopen={isopen}
                      page={page}
                      refreshAllData={refreshAllData}
                      refreshType={refreshType}
                      setRefreshtype={setRefreshtype}
                      setFailedRefreshId={setFailedRefreshId}
                      failedRefreshId={failedRefreshId}
                      successRefreshId={successRefreshId}
                      setSuccessRefreshId={setSuccessRefreshId}
                      currency={currency}
                      refreshAll={refreshAll}
                      typepop={typepop}
                      setIsNeft={setIsNeft}
                      setIsImps={setIsImps}
                      setIsRtgs={setIsRtgs}
                      txnPayLoad={txnPayLoad}
                      setTxnPayLoad={setTxnPayLoad}
                      BenEnableNextButton={BenEnableNextButton}
                      setOpenOwner={setOpenOwner}
                      flow={flow}
                      handleViewStatement={handleViewStatement}
                      ownerAccBalanceLoading={ownerAccBalanceLoading}
                      ownerAccBalanceError={ownerAccBalanceError}
                      navigate={navigate}
                      dispatch={dispatch}
                      accId={accId}
                      setAccId={setAccId}
                      setStatementId={setStatementId}
                      setAccData={setAccData}
                      prevId={
                        refreshType === "all"
                          ? refreshAllData?.find((id) => item.id === id.id)?.id
                          : prevId
                      }
                      setPrevId={setPrevId}
                      prevBalance={
                        refreshType === "all"
                          ? refreshAllData?.find((id) => item.id === id.id)
                              ?.prevbalance
                          : prevBalance
                      }
                      setPrevBalance={setPrevBalance}
                      setPrev_Total_balance_state={setPrev_Total_balance_state}
                      total_balance={total_balance}
                      handleButtonClick={handleButtonClick}
                      favouritesFilter={favouritesFilter}
                      multiSelect={multiSelect}
                      isAssignTagsClicked={isAssignTagsClicked}
                      isLabelClicked={isLabelClicked}
                      handleOwnerAccountSelect={handleOwnerAccountSelect}
                      owneraccountnumberstate={owneraccountnumberstate}
                      setowneraccountnumberstate={setowneraccountnumberstate}
                      popType={popType}
                      setRefactorAccDetail={setRefactorAccDetail}
                    />
                  );
                })
              ) : (
                <p
                  style={{ paddingLeft: "var(--padding-sm)" }}
                  className="noaccountfound"
                >
                  No accounts were found with a negative balance.
                </p>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="standard-list-view-alignment">
          {listdata.map((item, index) => {
            return (
              <OwnerAccountListViewComp
                filterRef={filterRef}
                index={index}
                item={item}
                handleRefresh={handleRefresh}
                isopen={isopen}
                page={page}
                refreshAllData={refreshAllData}
                refreshType={refreshType}
                setRefreshtype={setRefreshtype}
                setFailedRefreshId={setFailedRefreshId}
                failedRefreshId={failedRefreshId}
                successRefreshId={successRefreshId}
                setSuccessRefreshId={setSuccessRefreshId}
                currency={currency}
                refreshAll={refreshAll}
                typepop={typepop}
                setIsNeft={setIsNeft}
                setIsImps={setIsImps}
                setIsRtgs={setIsRtgs}
                txnPayLoad={txnPayLoad}
                setTxnPayLoad={setTxnPayLoad}
                BenEnableNextButton={BenEnableNextButton}
                setOpenOwner={setOpenOwner}
                flow={flow}
                handleViewStatement={handleViewStatement}
                ownerAccBalanceLoading={ownerAccBalanceLoading}
                ownerAccBalanceError={ownerAccBalanceError}
                navigate={navigate}
                dispatch={dispatch}
                accId={accId}
                setAccId={setAccId}
                setStatementId={setStatementId}
                setAccData={setAccData}
                prevId={
                  refreshType === "all"
                    ? refreshAllData?.find((id) => item.id === id.id)?.id
                    : prevId
                }
                setPrevId={setPrevId}
                prevBalance={
                  refreshType === "all"
                    ? refreshAllData?.find((id) => item.id === id.id)
                        ?.prevbalance
                    : prevBalance
                }
                setPrevBalance={setPrevBalance}
                setPrev_Total_balance_state={setPrev_Total_balance_state}
                total_balance={total_balance}
                handleButtonClick={handleButtonClick}
                favouritesFilter={favouritesFilter}
                multiSelect={multiSelect}
                isAssignTagsClicked={isAssignTagsClicked}
                handleOwnerAccountSelect={handleOwnerAccountSelect}
                owneraccountnumberstate={owneraccountnumberstate}
                setowneraccountnumberstate={setowneraccountnumberstate}
                popType={popType}
                setRefactorAccDetail={setRefactorAccDetail}
                isLabelClicked={isLabelClicked}
              />
            );
          })}
        </div>
      )}
    </>
  );
};

export default OwnerAccountListView;
